// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-modal__backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  padding: 1.25rem;
  background: rgba(15, 23, 42, 0.45);
}

.settings-modal {
  width: min(100%, 420px);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.settings-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid var(--color-border);
}

.settings-modal__header h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.settings-modal__close {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.settings-modal__close:hover {
  background: var(--color-accent-soft);
  color: var(--color-accent);
}

.settings-modal__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.1rem;
}

.settings-modal__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.settings-modal__copy {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.settings-modal__copy strong {
  font-size: 0.92rem;
  font-weight: 700;
}

.settings-modal__copy span {
  color: var(--color-text-muted);
  font-size: 0.78rem;
  line-height: 1.35;
}

.settings-toggle {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: var(--color-border);
  cursor: pointer;
  transition: background 0.2s ease;
}

.settings-toggle--on {
  background: var(--color-accent);
}

.settings-toggle__thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
}

.settings-toggle--on .settings-toggle__thumb {
  transform: translateX(18px);
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".settings-modal__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: grid;\n  place-items: center;\n  padding: 1.25rem;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.settings-modal {\n  width: min(100%, 420px);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.settings-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1rem 1.1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.settings-modal__header h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.settings-modal__close {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.settings-modal__close:hover {\n  background: var(--color-accent-soft);\n  color: var(--color-accent);\n}\n\n.settings-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.1rem;\n}\n\n.settings-modal__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.settings-modal__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.settings-modal__copy strong {\n  font-size: 0.92rem;\n  font-weight: 700;\n}\n\n.settings-modal__copy span {\n  color: var(--color-text-muted);\n  font-size: 0.78rem;\n  line-height: 1.35;\n}\n\n.settings-toggle {\n  position: relative;\n  flex-shrink: 0;\n  width: 44px;\n  height: 26px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: var(--color-border);\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.settings-toggle--on {\n  background: var(--color-accent);\n}\n\n.settings-toggle__thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease;\n}\n\n.settings-toggle--on .settings-toggle__thumb {\n  transform: translateX(18px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
